__turbopack_context__.v({
  "className": "dancing_script_81d107ed-module__gPQtkW__className",
});
